import React from "react";
import ProfitReport from "./ProfitReport";

// Api/Reports/GroupwiseProfitReport - see ProfitReport.jsx
const GroupWiseProfit = () => <ProfitReport kind="group" />;

export default GroupWiseProfit;
